module Meevo.Plugins.ControlGallery {
  export class CustomModalController {
    private modal : angular.material.IDialogService

    constructor($mdDialog: angular.material.IDialogService) {
      let vm = this;
      vm.modal = $mdDialog;
    }

    close(): void {
      this.modal.hide();
    }


  }
  angular.module("meevo.plugins.controlgallery")
    .controller("meevo.plugins.controlgallery.CustomModalController", CustomModalController);
}